import { DropDownList, DropDownListChangeEvent } from "@progress/kendo-react-dropdowns";
import { promises } from "dns";
import React, { Fragment, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ErrorMessage from "../Common/Components/ErrorMessage";
import Spinner from "../Common/Components/spinner";
import { getParamsSelector } from "../Common/Slices/ParamSlice";
import { AlarmApi } from "./api";

interface AlarmDetailsWidgetProps{
    id:string;
    header: string;
}

const AlarmDetailsWidget = (props:AlarmDetailsWidgetProps) => {
    const [alarmDetails, updateAlarmDetails] = useState([]);
    const [tableData, updateTableData] = useState([]);
    const [languages, updateLanguages] = useState([]);
    const [loadingState, updateLoadingState] = useState("pending");
    const [selectedLanguage, setSelectedLanguage] = useState({language:"English", locale:"en-US"});
    const params = useSelector(getParamsSelector)
    
    useEffect(()=>{
        if(params.alarmText !== null){
            fetchAlarmDetails()
        }
    },[params.alarmText])

    useEffect(()=>{
        const detailsInLanguage =  alarmDetails.filter((obj)=>obj.locale === selectedLanguage.locale)
        updateTableData(detailsInLanguage)
    },[alarmDetails])

    const fetchAlarmDetails = () =>{
        AlarmApi.getLocales().then((res:any)=>{
            updateLanguages(res)
            AlarmApi.getAlarmDetails(params.alarmText).then((res:any)=>{
                updateAlarmDetails(res)
                updateLoadingState("fulfilled")
            }).catch(error =>{
                updateLoadingState("rejected")
                return Promise.reject();
            });
        }).catch(error =>{
            updateLoadingState("rejected")
            return Promise.reject();
        });
    }

    const languageHandler = (event:DropDownListChangeEvent) => {
        setSelectedLanguage(event.target.value)
        const detailsInLanguage =  alarmDetails.filter((obj)=>obj.locale === event.target.value.locale)
        updateTableData(detailsInLanguage)
        
    }

    const renderTable = () => {
        if(tableData.length > 0){
            return (
                <div>
                    {tableData.map((obj,i) => (
                        <div key={i} style={{marginTop:"10px"}}>
                            <table>
                                <tbody>
                                    <tr>
                                        <td style={{whiteSpace:"nowrap"}}><strong>Original text:</strong></td>
                                        <td>{params.alarmText}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Text:</strong></td>
                                        <td>{obj.text}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Alarm No:</strong></td>
                                        <td>{obj.alarmNo}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Alarm File:</strong></td>
                                        <td>{obj.alarmFile}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Description:</strong></td>
                                        <td>{obj.description}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Remedy:</strong></td>
                                        <td>{obj.remedy}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    ))}
                </div>
            )
        }else{
            return null;
        }
    }
    if(loadingState === "pending"){
        return <Spinner text="data" />;
    }
    if (alarmDetails == null  || loadingState === "rejected") {
        //proper error handling should be added with promise error response
        return (
            <ErrorMessage
                text={"Oops something went wrong, unable to get data."}
                id={props.id}
                header={props.header}
            />
        );
    } 
    if(loadingState === "fulfilled" && alarmDetails.length === 0){
        return (
            <ErrorMessage
                text={"No data found for selected alarm"}
                id={props.id}
                header={props.header}
            />
        );
    }
    return (
        <Fragment>
            <DropDownList 
            data={languages}
            textField="language"
            value={selectedLanguage}
            onChange={languageHandler}
            />
            {renderTable()}
        </Fragment>
    )
}

export default AlarmDetailsWidget;